import { useState } from 'react';
import dayjs from 'dayjs';
import useInterval from './useInterval';

export type TimerState =
  | 'hidden' // 非表示
  | 'displayTimer' // タイマー表示
  | 'forceExitPhase1' // 強制退出メッセージ第１（黄色）
  | 'forceExitPhase2' // 強制退出メッセージ第２（赤色）
  | 'finished'; // 終了
const timerSecond = 3 * 60;
const forceExitTimerSecond = 60;
const forceExitSecond = 30;
const useTimer = (endDatetime?: Date) => {
  const [timerState, setTimerState] = useState<TimerState>('hidden');
  const [timerDuration, setTimerDuration] = useState(0);
  const [remainingSecondsToClose, setRemainingSecondsToClose] = useState(forceExitTimerSecond);
  const end = dayjs(endDatetime);

  useInterval(() => {
    const now = dayjs();
    const remaing = end.diff(now, 's');
    // 180秒以上の場合は180秒で固定
    const timerDuration = remaing < timerSecond ? remaing : timerSecond;

    setTimerDuration(timerDuration);
    const remaingClose = forceExitTimerSecond - remaing * -1;

    // レッスン終了後１分以上経過
    const finished = forceExitTimerSecond <= now.diff(end, 's');
    // レッスン終了後30秒以上経過
    const forceExitPhase2 = forceExitSecond <= now.diff(end, 's') && now.diff(end, 's') < forceExitTimerSecond;
    // レッスン終了時刻超過 終了時刻 < 現在時刻+30秒未満
    const forceExitPhase1 = 0 < now.diff(end, 's') && now.diff(end, 's') < forceExitSecond;
    // レッスン終了時刻3分前～レッスン終了時刻
    const displayTimer = timerSecond * -1 <= now.diff(end, 's') && now.diff(end, 's') <= 0;
    // レッスン中
    const hidden = now.diff(end, 's') < timerSecond * -1;

    if (finished) {
      setTimerState('finished');
    } else if (forceExitPhase2) {
      setTimerState('forceExitPhase2');
      setRemainingSecondsToClose(remaingClose);
    } else if (forceExitPhase1) {
      setTimerState('forceExitPhase1');
      setRemainingSecondsToClose(remaingClose);
    } else if (displayTimer) {
      setTimerState('displayTimer');
    } else if (hidden) {
      setTimerState('hidden');
    }
  }, 1000);
  return { timerState, timerDuration, remainingSecondsToClose };
};
export default useTimer;
